import { Tabs } from 'components/core-v2'
import { useLocation } from 'react-router-dom'

import { PATH } from '@/const'

export const ReportingPageTabs = () => {
  const { pathname } = useLocation()
  const tab = pathname.split('/')[2]

  return (
    <Tabs.List aria-label="Reporting pages" className="ml-4" spacing="lg">
      <Tabs.Tab isSelected={tab === 'overview'} to={PATH.reportsOverview} value="overview">
        Overview
      </Tabs.Tab>
      <Tabs.Tab isSelected={tab === 'notes'} to={PATH.reportsNotes} value="notes">
        Notes
      </Tabs.Tab>
      <Tabs.Tab isSelected={tab === 'trades'} to={PATH.reportsTrades} value="trades">
        Trades
      </Tabs.Tab>
    </Tabs.List>
  )
}
